import { shouldBeInvoiced } from "Client/Detail/SubscriptionUtils";
import React from "react";

interface Props {
  type: server.dto.SubscriptionType
  cycle: server.dto.BillingCycle
}

const PlanLabel = ({ type, cycle }: Props) => {
  return (<div className="flex margin-bottom-small">
    <div className="grow1"><strong>{type.internalText}</strong></div>
    {shouldBeInvoiced(type.value) && <div>{cycle.text}</div>}
  </div>);
};

export default PlanLabel;